// extracted by mini-css-extract-plugin
export default {"AdditionalInformationContainer":"_AdditionalInformationContainer--ghxhl","InfoText":"_InfoText--m93Qt","AdditionalInformation":"_AdditionalInformation--fYVvv","Link":"_Link--pTnuk"};